module.exports = __webpack_public_path__ + "9106766.woff2";